// import Menu from "../component/menu/Menu";
import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import aboutImg from "../Images/Rectangle.png"
// import pic from "../Images/anees2.jpg"
import Stack from "@mui/material/Stack";
import Rating from "@mui/material/Rating";
import Footer from "./Footer";
import Menu from "../component/menu/Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { baseurl } from "./BaseURL/BaseURL";
import { trackAddToCart, trackInitiateCheckout } from "../lib/fbPixel";

function BuyTittle({ model = "card" }) {
  const [activeSection, setActiveSection] = useState("description");
  const [ShowReviewForm, SetShowReviewForm] = useState(false);
  const [add, setadd] = useState(0);
  const [Data, setData] = useState(null);
  const [reviewsData, setReviewsData] = useState([]);
  const [reviewFormData, setReviewFormData] = useState({
    name: "",
    email: "",
    rating: 0,
    Review: "",
  });

  const navigate = useNavigate();
  const { id } = useParams();
  // Always scroll to top when arriving on this page or when product id changes
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [id]);
  // localStorage.setItem("productid", id);
  const handleAddToCart = async () => {
    try {
      console.log("first");
      const token = localStorage.getItem("token");

      // Common pricing info for tracking
      const unitPrice = Data?.salePrice || Data?.price || 0;
      const qty = add && add > 0 ? add : 1;

      // Track AddToCart with Meta Pixel
      trackAddToCart({
        content_ids: [id],
        content_type: "product",
        contents: [
          {
            id,
            quantity: qty,
            item_price: unitPrice,
          },
        ],
        value: unitPrice * qty,
        currency: "PKR",
      });

      // If user is authenticated use backend cart
      if (token) {
        // For authenticated users keep original behavior: send product id (repeat by quantity)
        const productIds = [];
        for (let i = 0; i < (add || 1); i++) productIds.push(id);

        const response = await axios.post(
          `${baseurl}/cart`,
          { product_ids: productIds },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log("this cart data", response.data);
        navigate("/viewCart");
        return;
      }

      // Guest flow: manage cart in localStorage under key 'guestCart'
      const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
      const existingIndex = guestCart.findIndex((it) => it.productId === id);
      const qtyToAdd = qty;

      if (existingIndex > -1) {
        guestCart[existingIndex].quantity += qtyToAdd;
        guestCart[existingIndex].subtotal =
          guestCart[existingIndex].quantity * guestCart[existingIndex].price;
      } else {
        // Use locally fetched Data to populate item info
        guestCart.push({
          productId: id,
          title: Data?.title || "",
          url: Data?.url || "",
          price: Data?.salePrice || Data?.price || 0,
          quantity: qtyToAdd,
          subtotal: (Data?.salePrice || Data?.price || 0) * qtyToAdd,
        });
      }

      localStorage.setItem("guestCart", JSON.stringify(guestCart));
      // Also prepare checkout ids for single-product buy now / cart flows
      const checkoutIds = guestCart.map((it) => it.productId);
      localStorage.setItem("checkoutProductIds", JSON.stringify(checkoutIds));
      // compute subtotal including delivery
      const base = guestCart.reduce((s, it) => s + it.subtotal, 0);
      const delivery = base >= 3000 ? 0 : 200;
      localStorage.setItem("subtotal", String(base + delivery));
      navigate("/viewCart");
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const increment = () => setadd((s) => (s || 1) + 1);
  const decrement = () => setadd((s) => (s > 1 ? s - 1 : 1));
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setReviewFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Fetch product by id via React Query
  const productQuery = useQuery({
    queryKey: ["product", model, id],
    queryFn: async () => {
      let url;
      if (model === "newarrival") {
        url = `${baseurl}/newarrivel-get/${id}`;
      } else if (model === "event") {
        url = `${baseurl}/event-get/${id}`; // fallback if you add event route
      } else {
        url = `${baseurl}/getCard-id/${id}`;
      }
      const { data } = await axios.get(url);
      return data?.data || null;
    },
    enabled: !!id, // don't run until id exists
    staleTime: 2 * 60 * 1000, // 2 minutes
    retry: 1,
  });

  // Sync to local Data for minimal code changes
  if (productQuery.data && Data !== productQuery.data) {
    setData(productQuery.data);
  }

  console.log(Data);

  return (
    <>
      <Menu />
      {/* Loading / error states */}
      {productQuery.isLoading && (
        <div className="px-8 py-10">
          <div className="animate-pulse">
            <div className="h-80 w-full bg-slate-800/20 rounded" />
            <div className="mt-4 h-6 w-1/2 bg-slate-800/20 rounded" />
            <div className="mt-2 h-4 w-2/3 bg-slate-800/20 rounded" />
          </div>
        </div>
      )}
      {productQuery.error && (
        <div className="px-8 py-10 text-red-400">
          Failed to load product. Please try again.
        </div>
      )}
      {Data && (
        <div className="lg:flex gap-x-12 w-full px-2 lg:px-8 pt-8 ">
          <div className="lg:w-[40%] px-4 flex items-center justify-center sm:flex-none sm:items-start w-full lg:ml-12">
            <img
              src={Data.url}
              className="w-[80%] h-[370px] rounded-md sm:h-[400px] lg:h-[660px] sm:w-[80%]"
              alt=""
            />
          </div>
          <div className="w-full lg:w-[61%] py-4">
            <div className="flex flex-col gap-y-5">
              <h1 className="font-semibold">{Data.category}</h1>
              <h1 className="font-semibold block sm:hidden">
                Written by{" "}
                <span className="font-bold text-black"> {Data.author} </span>
              </h1>
              <h1 className="font-bold text-2xl">{Data.title}</h1>
              <div className="flex gap-x-2">
                <h1 className="text-2xl text-black hidden lg:block font font-semibold">
                  Rs {Data.salePrice}
                </h1>
                <h1 className="text-xl text-gray-600 hidden line-through lg:block font font-semibold">
                  Rs {Data.price}
                </h1>
              </div>
              <h1 className="text-gray-600 hidden lg:block font-semibold">
                Written by{" "}
                <span className="font-bold text-black"> {Data.author} </span>
              </h1>
              <p className="text-gray-500 text-justify lg:w-[75%]">
                {Data.description}
              </p>
              {/* <h1 className="font-semibold">{Data.sold} sold <span className="text-gray-600 text-sm">since last month</span></h1> */}
              {/* <h1 className="text-[#f4b230] ">Favourite this</h1> */}
              <div className="flex gap-x-2">
                <h1 className="text-black block lg:hidden font-semibold">
                  Rs {Data.salePrice}
                </h1>
                <h1 className="text-gray-600 block lg:hidden font-semibold line-through">
                  Rs {Data.price}
                </h1>
              </div>
              <div>
                <h1>Rs 200 Delivery charges</h1>
              </div>
              <hr className="w-1/2" />
            </div>
            <div className="flex pt-4 gap-x-10">
              {/* <div className="flex" >
                <h1 className="border cursor-pointer px-3 py-1 font-semibold " onClick={decrement}>-</h1>
                <h1 className="border  px-2 py-1">{add}</h1>
                <h1 className="border cursor-pointer px-3 py-1" onClick={increment}>+</h1>
              </div> */}
              <div className="flex items-center gap-x-4">
                <button
                  onClick={decrement}
                  aria-label="Decrease quantity"
                  title="Decrease"
                  className="w-10 h-10 border rounded-full bg-white shadow-md flex items-center justify-center text-2xl font-bold text-gray-700 hover:scale-105 transition-transform focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
                >
                  −
                </button>

                <div className="w-14 text-center font-semibold text-lg">
                  {add || 1}
                </div>

                <button
                  onClick={increment}
                  aria-label="Increase quantity"
                  title="Increase"
                  className="w-10 h-10 rounded-full bg-[#f4b230] shadow-md flex items-center justify-center text-2xl font-bold text-black hover:scale-105 transition-transform focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f4b230]"
                >
                  +
                </button>
              </div>
              <button
                onClick={handleAddToCart}
                className="w-[50%]  py-2  rounded-lg bg-[#f4b230]"
              >
                ADD TO CART
              </button>
            </div>
            <div className="pt-4 px-2">
              <button
                className="w-[50%]  rounded-lg py-2 bg-black text-white"
                onClick={() => {
                  // For guest ensure checkoutProductIds and subtotal are set
                  const token = localStorage.getItem("token");
                  if (!token) {
                    const guestCart =
                      JSON.parse(localStorage.getItem("guestCart")) || [];
                    // If no guest cart, add current product as single checkout
                    if (guestCart.length === 0) {
                      const qty = add && add > 0 ? add : 1;
                      const item = {
                        productId: id,
                        title: Data?.title || "",
                        url: Data?.url || "",
                        price: Data?.salePrice || Data?.price || 0,
                        quantity: qty,
                        subtotal: (Data?.salePrice || Data?.price || 0) * qty,
                      };
                      localStorage.setItem("guestCart", JSON.stringify([item]));
                    }
                    const guest =
                      JSON.parse(localStorage.getItem("guestCart")) || [];
                    const ids = guest.map((g) => g.productId);
                    localStorage.setItem(
                      "checkoutProductIds",
                      JSON.stringify(ids)
                    );
                    const base = guest.reduce((s, it) => s + it.subtotal, 0);
                    const delivery = base >= 3000 ? 0 : 200;
                    localStorage.setItem("subtotal", String(base + delivery));
                  }
                  // Track InitiateCheckout for BUY NOW flow
                  try {
                    const guest =
                      JSON.parse(localStorage.getItem("guestCart")) || [];
                    const productIds = guest.map((g) => g.productId || id);
                    const base = guest.reduce((s, it) => s + (it.subtotal || 0), 0);
                    const delivery = base >= 3000 ? 0 : 200;
                    const total = base + delivery;
                    trackInitiateCheckout({
                      content_ids: productIds,
                      content_type: "product",
                      num_items: productIds.length,
                      value: total,
                      currency: "PKR",
                    });
                  } catch (e) {
                    console.error("Failed to track InitiateCheckout", e);
                  }
                  console.log(
                    "Navigating to checkout (BUY NOW) - token present:",
                    !!token
                  );
                  navigate(token ? "/checkout" : "/guest-checkout");
                }}
              >
                BUY NOW
              </button>
            </div>
            <div className="pt-6 flex flex-col gap-y-2">
              <h1 className="text-gray-500">
                Estimate Delivery Time{" "}
                <span className="text-black font-semibold">: 02-03 days</span>
              </h1>
              <h1 className="text-gray-500">Return in 05 days</h1>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}

export default BuyTittle;
